import React from "react";

import "./RadioButton.scss";

const RadioButton = ({ groupBySegment, value }) => {
    return (
        <button className={`${value ? 'slider-active' : 'slider'}`} onClick={groupBySegment}>
            <span className={` ${value ? 'slider__button-active' : 'slider__button'}`}/>
        </button>
    );
};

export default RadioButton;
